import ApiService from "./api.service";

const EstadoService = {
  async getEstados(params) {
    return await ApiService.get("/estados", params);
  },
};

export default EstadoService;
